import http from "../http";
import {queryClient} from "../client";
import {usePermission} from "./usePermission";
import {useRole} from "./useRole";
import {computed, watchEffect} from "vue";
import store from "../store";

const {setPermissions} = usePermission();

export function useUser() {
  const current = async () => await http.get('/api/user/current', {silence: true}).then(response => {
    queryClient.setQueryData('userCurrent', () => response);

    http.defaults.headers.common['Current-Brand-Id'] = response.data.current_brand_id;

    const permissions = [];

    response.data.roles.forEach(role => {
      permissions.push(...role.permissions)
    });

    setPermissions(permissions);

    return response;
  });

  const swapBrand = async (brandId) => await http.post(`/api/user/brands/${brandId}/switch`);
  const forgotPassword = async (email) => await http.post('/password/email', {email});
  const resetPassword = async (email, password, token, password_confirmation) => await http.post('/password/reset', {
    email, password, token, password_confirmation
  });
  const updateAddress = async address => await http.post('/api/user/address', address);
  const updatedCurrentUserPassword = async (current_password, password, password_confirmation) => await http.post('/api/user/password', {
    current_password, password, password_confirmation
  });
  const registerAsBrand = async (data) => await http.post('/api/register/brand', data);
  const registerAsCreator = async (data) => await http.post('/api/register/creator', data);

  const updateRegisterCreatorProfile = async data => await http.post('/api/register/creator/profile', data);
  const updateRegisterCreatorDemographics = async data => await http.post('/api/register/creator/demographics', data);
  const updateRegisterCreatorSocials = async data => await http.post('/api/register/creator/socials', data);
  const updateRegisterCreatorShippingAddress = async data => await http.post('/api/register/creator/address', data);
  const updateRegisterCreatorPromoVideo = async data => await http.post('/api/register/creator/promo-video', data);
  const finishCreatorRegistration = async () => await http.post('/api/register/creator/finish-registration');
  const finishBrandRegistration = async () => await http.post('/api/register/brand/finish-registration');

  const isRegistrationFinished = computed(() => {
    const user = store?.getters['auth/user'] || {};

    return user.registration_completed;
  });

  const getFormattedFullName = (user = {}) => {
    if (user !== null) {
      if (isUserActive(user)) {
        if (!user.first_name) {
          return user.full_name;
        }

        return user.first_name + (user.last_name ? ' ' + user.last_name[0] + '.' : '');
      } else {
        return user.full_name;
      }
    }
  }

  const isUserActive = (user) => {
    return user?.status === 'ACTIVE';
  }

  return {
    current,
    swapBrand,
    forgotPassword,
    resetPassword,
    updateAddress,
    updatedCurrentUserPassword,
    registerAsBrand,
    registerAsCreator,
    updateRegisterCreatorProfile,
    updateRegisterCreatorDemographics,
    updateRegisterCreatorSocials,
    updateRegisterCreatorShippingAddress,
    updateRegisterCreatorPromoVideo,
    finishCreatorRegistration,
    finishBrandRegistration,
    isRegistrationFinished,
    getFormattedFullName,
    isUserActive,
  }
}
